import { useRoles } from './useRoles';

/**
 * Prefijo de ruta según el perfil del usuario: `backoffice` o `simp`.
 *
 * Todas las rutas de `AdminLayout` se declaran como `${routePrefix}/...`, así que
 * cualquier `navigate()` con path absoluto tiene que incluirlo. Sin el prefijo la
 * URL no matchea ninguna ruta y cae en `PageNotFound`.
 *
 * La misma lógica está duplicada en `AdminLayout.tsx` y en
 * `Menu/components/MenuAccesItem.tsx`. Se extrae acá para no escribirla una
 * tercera vez; unificar las otras dos queda como deuda (tocan routing crítico).
 */
export const useRoutePrefix = (): string => {
    const {
        isAdminBO,
        isViewerBO,
        isPreventor,
        isAuditor,
        isProvider,
        isAuditorFacturacion,
        isSupervisorSIMP,
        isOperatorSIMP,
        isRRHHSIMP
    } = useRoles();

    if (
        isAdminBO ||
        isViewerBO ||
        isPreventor ||
        isAuditor ||
        isProvider ||
        isAuditorFacturacion
    ) {
        return 'backoffice';
    }

    if (isSupervisorSIMP || isOperatorSIMP || isRRHHSIMP) {
        return 'simp';
    }

    return 'prefixError';
};

export default useRoutePrefix;
